import { render, staticRenderFns } from "./defaultEditors.vue?vue&type=template&id=2d183b43"
import script from "./defaultEditors.vue?vue&type=script&lang=js"
export * from "./defaultEditors.vue?vue&type=script&lang=js"
import style0 from "./defaultEditors.vue?vue&type=style&index=0&id=2d183b43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports